export const idVerificationStatus = {
  success: 'success',
  pending: 'pending',
  failed: 'failed',
  notYet: 'not_yet'
}